import {mapGetters, mapActions} from 'vuex';

export default {
    computed: {
        ...mapGetters(['getCart', 'getCartCount', 'getCartItem']),
    },
    methods: {
        ...mapActions(['cartAdd', 'cartDel', 'cartReset', 'cartReset', 'cartQty'])
    },
}

